<template>
  <div class="container">
    <div class="header">
      <div class="w1250">
        <z-header></z-header>
      </div>
    </div>
    <z-navigation
      :update="false"
      form-name="form"
      v-on:submit_form="submitForm"
    ></z-navigation>
    <div class="main w1200" v-if="pageInfo.hasOwnProperty('pageInfo')">
      <z-breadcrumb
        v-if="pageInfo.pageInfo.hasOwnProperty('breadcrumbs')"
        :options="pageInfo.pageInfo.breadcrumbs"
      ></z-breadcrumb>
      <form-card
        v-if="pageInfo.hasOwnProperty('form')"
        ref="form"
        :form-data="pageInfo.form.field"
        :form-inputs="pageInfo.form.form_field"
        :form-rules="pageInfo.form.rules"
        :id="pageInfo.form.id"
        :options="pageInfo.form.options"
        :name="pageInfo.form.name"
        v-on:formEvent="formEvent"
      >
        <div slot="formHeader" class="bzBg">
          <div class="bzDiv">
            <div class="bzCon-two fL">
              <div class="bzNum fL marR8 success" style="display:flex;align-items:center">
                <i class="el-icon-circle-check icon-circle-success marR8"/>
                填写基本信息
              </div>
              <div class="line fL marR8">----------</div>
              <div class="bzNum fL marR8 success">
                <div class="fL icon-circle-open marR8">2</div>
                上传资质信息
              </div>
            </div>
            <div class="bzBtn-two fL">
              <el-button
                class="fL marR20"
                @click="previousForm()"
                >上一步</el-button
              >
              <el-button
                class="fL marR20"
                @click="cancelForm()"
                >取消</el-button
              >
              <el-button
                type="primary"
                class="fL"
                @click="submitForm(pageInfo.form.options.ref)"
                >提交审核
              </el-button>
            </div>
          </div>
          <z-alert :tag-msg="pageInfo.pageInfo.tag_msg"></z-alert>
        </div>
      </form-card>
    </div>
  </div>
</template>
<script>
/* eslint-disable */
import FormCard from "@/components/form/Form";
import { getData, saveData } from "../utils/utils";
import Navigation from "@/components/Navigation";
import qs from "qs";
export default {
  name: "License",
  components: {
    "form-card": FormCard,
    "z-navigation": Navigation,
  },
  data: function () {
    return {
      pageInfo: {},
      options: {},
      formValidate: false,
      formData: {},
      tagMsg: {},
      packageId: 0,
      isDisable: true,
    };
  },
  computed: {
    isBrandZZFlag: function () {
      return window.location.host.includes('brand')
    },
  },
  watch: {
    pageInfo: function (newData, oldData) {},
  },
  created: function () {
    let packageId = this.$route.params.package_id || 0;
    let params = { package_id: packageId };
    if (this.$route.query["customer_id"]) {
      params["customer_id"] = this.$route.query["customer_id"];
    }
    if (this.$route.query["clientId"]) {
      params["clientId"] = this.$route.query["clientId"];
    }
    if (this.$route.query["loginParam"]) {
      params["loginParam"] = this.$route.query["loginParam"];
    }
    if (packageId === 0) {
      this.$message.warning("非法操作");
      // this.$router.push("/");
      this.cancelForm()
    } else {
      getData(
        this.isBrandZZFlag
          ? "/api/package/crm/addSecond"
          : "/api/package/addSecond",
        params,
        (res) => {
          if (res.code == 0) {
            this.pageInfo = res.data;
            if (this.pageInfo.hasOwnProperty("form")) {
              if (this.pageInfo.form.rules instanceof Array) {
                this.pageInfo.form.rules = {};
              }
              if (this.pageInfo.form.form_field.length === 0) {
                this.$message.warning(
                  "系统行业错误，没有找到需要的资质信息"
                );
                this.previousForm();
              }
            }
          } else {
            this.$message.warning(res.msg);
            let url = "/";
            let urlHash = {};
            if (this.$route.query["customer_id"]) {
              urlHash["customer_id"] = this.$route.query["customer_id"];
            }
            if (this.$route.query["clientId"]) {
              urlHash["clientId"] = this.$route.query["clientId"];
            }
            if (this.$route.query["loginParam"]) {
              urlHash["loginParam"] = this.$route.query["loginParam"];
            }
            url =
              Object.keys(urlHash).length > 0
                ? url + `?${qs.stringify(urlHash)}`
                : url;
            this.$router.push(url);
          }
        }
      );
    }
  },
  mounted: function () {
    this.packageId = this.$route.params.package_id || 0;
  },
  methods: {
    submitForm: function (formName) {
      this.$refs["form"].$emit("validate");
      if (this.formValidate && this.isDisable) {
        this.isDisable = false;
        saveData(
          this.pageInfo.form.options.action,
          this.formData,
          (res) => {
            this.isDisable = true;
            this.$alert("预计需要2小时可以审核完成","已提交审核",
              {
                confirmButtonText: '确定',
                showClose:false,
                center:true,
                callback: () => {
                  let url = "/qulification/" + this.packageId;
                  let urlHash = {};
                  if (this.$route.query["customer_id"]) {
                    urlHash["customer_id"] = this.$route.query["customer_id"];
                  }
                  if (this.$route.query["clientId"]) {
                    urlHash["clientId"] = this.$route.query["clientId"];
                  }
                  if (this.$route.query["loginParam"]) {
                    urlHash["loginParam"] = this.$route.query["loginParam"];
                  }
                  url =
                    Object.keys(urlHash).length > 0
                      ? url + `?${qs.stringify(urlHash)}`
                      : url;
                  this.$router.push(url);
                },
              },
            );
          },
          (errs) => {}
        );
        setTimeout(() => {
          this.isDisable = true;
        }, 500);
      }
      return false;
    },
    formEvent: function (form) {
      this.formValidate = form.valid;
      // this.formData = form.data
      this.formData = Object.assign({}, this.formData, form.data);
      if (this.$route.query["customer_id"]) {
        this.formData["customer_id"] = this.$route.query["customer_id"];
      }
      if (this.$route.query["clientId"]) {
        this.formData["clientId"] = this.$route.query["clientId"];
      }
      if (this.$route.query["loginParam"]) {
        this.formData["loginParam"] = this.$route.query["loginParam"];
      }
    },
    cancelForm: function () {
      let url = "/";
      let urlHash = {};
      if (this.$route.query["customer_id"]) {
        urlHash["customer_id"] = this.$route.query["customer_id"];
      }
      if (this.$route.query["clientId"]) {
        urlHash["clientId"] = this.$route.query["clientId"];
      }
      if (this.$route.query["loginParam"]) {
        urlHash["loginParam"] = this.$route.query["loginParam"];
      }
      url =
        Object.keys(urlHash).length > 0
          ? url + `?${qs.stringify(urlHash)}`
          : url;
      this.$router.push(url);
    },
    previousForm: function () {
      if (!this.packageId) {
        this.packageId = this.$route.params.package_id || 0;
      }
      let url = "/qulification/base/" + this.packageId;
      let urlHash = {};
      if (this.$route.query["customer_id"]) {
        urlHash["customer_id"] = this.$route.query["customer_id"];
      }
      if (this.$route.query["clientId"]) {
        urlHash["clientId"] = this.$route.query["clientId"];
      }
      if (this.$route.query["loginParam"]) {
        urlHash["loginParam"] = this.$route.query["loginParam"];
      }
      url =
        Object.keys(urlHash).length > 0
          ? url + `?${qs.stringify(urlHash)}`
          : url;
      this.$router.push(url);
    },
  },
};
</script>
<style>
.success {
  color: #2a60e4;
}

.line {
  color: #e3e7f1;
  line-height: 38px;
}

.bzDiv {
  overflow: hidden;
  padding-bottom: 5px;
}

.bzCon-two {
  width: 797px;
  display: flex;
  align-items: center;
}

.bzBtn-two {
  width: 403px;
}

.tipTxt {
  font-size: 14px;
  color: #2e334a;
}

.bzBg {
  background: #f9f9f9;
  padding-bottom: 10px;
}

.icon-circle-open {
  background: #2a60e4;
  width: 24px;
  height: 24px;
  -moz-border-radius: 50px;
  -webkit-border-radius: 50px;
  border-radius: 50%;
  text-align: center;
  font-size: 12px;
  color: #ffffff;
  letter-spacing: 0.4px;
  line-height: 24px;
}

.icon-circle-close {
  background: #8f98b9;
  width: 24px;
  height: 24px;
  -moz-border-radius: 50px;
  -webkit-border-radius: 50px;
  border-radius: 50%;
  text-align: center;
  font-size: 16px;
  color: #ffffff;
  line-height: 24px;
}

.icon-circle-success {
  color: #2a60e4;
  font-size: 24px;
}

.bzDiv > span {
  padding-top: 12px;
  font-size: 14px;
  font-size: 14px;
  color: #2e334a;
  letter-spacing: 0;
  line-height: 16px;
  padding-right: 30px;
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/components/License.vue